<div class="modal-body">
    <div class="row">
        <div class="col-auto mb-3">
            Would you like to upgrade your membership level?
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" (click)="sendUpgradeInterest()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Yes</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100">No</button>
</div>